var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRefrigerated = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.00999999L2 0C0.9 0 0 0.89 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.89 15.1 0.00999999 14 0.00999999ZM14 18H2V8.98H14V18ZM14 7H2V2H14V7ZM4 3H6V6H4V3ZM4 10H6V15H4V10Z",
    fill: "#808080"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefrigerated, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Refrigerated.981dae15.svg";
export { ForwardRef as ReactComponent };